import axios, { AxiosError, AxiosInstance } from "axios";

// Base URL dành riêng cho track-video API
const trackBaseURL = process.env.REACT_APP_TRACK_API_URL;

// Tạo instance mới
export const trackApiInstance: AxiosInstance = axios.create({
  baseURL: trackBaseURL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

// Interceptor (nếu cần dùng token riêng)
// Nếu không cần thì có thể bỏ phần này
trackApiInstance.interceptors.request.use(
  (config) => {
    // Nếu track API cần token riêng, lấy từ sessionStorage (hoặc không cần thì xóa phần này)
    const token = sessionStorage.getItem("trackToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Hàm xử lý lỗi giống apiInstance
export const handleTrackApiError = (error: AxiosError) => {
  if (process.env.NODE_ENV === "development") {
    console.error("Track API Error:", error.response?.status, error.message);
  }
  throw error.response?.data || error?.message;
};
